import ApiService from "@/services/api.service"

export const UsersService = {
  login(params) {
    return ApiService.post("auth/login", params)
  },
  init(superadmin = false, loader = true) {
    return ApiService.get((superadmin ? "superadmin/" : "")+"initial", {}, { loader })
  },
  counters() {
    return ApiService.get("counters", {}, { loader: false })
  },
  getProfile() {
    return ApiService.get("profile")
  },
  fcmToken(params) {
    return ApiService.post("token/fcm", params)
  },
  getCurrentIp() {
    return ApiService.get("ip")
  },
  getSessions() {
    return ApiService.get("profile/sessions")
  },
  getFailedLogins() {
    return ApiService.get("profile/failed-logins")
  },
  getCurrentLegalDocuments() {
    return ApiService.get("legal-documents/current")
  },
  acceptLegalDocument(documentId) {
    return ApiService.post("legal-documents/accept", { document_id: documentId })
  },
  invalidateToken(tokenId = '') {
    return ApiService.post("token/invalidate", { tokenId })
  },
  changePassword(params) {
    return ApiService.post("auth/password/change", params)
  },
  forgotPassword(username) {
    return ApiService.post("auth/password/forgot", { username })
  },
  sendStaffPasswordResetLink(id, superadminClinicId = null) {
    if(superadminClinicId) return ApiService.post(`superadmin/clinic/${superadminClinicId}/user/${id}/password/reset-link`)
    return ApiService.post(`staff/${id}/password/reset-link`)
  },
  resetPassword(params) {
    return ApiService.post("auth/password/reset", params)
  },
  getPasswordRequirements() {
    return ApiService.get("auth/password/requirements", {}, { loader: false })
  },
  twofactorGenerateQR() {
    return ApiService.post("2fa/qr")
  },
  twofactorVerifyCode(code) {
    return ApiService.post("2fa/verify", { code })
  },
  twofactorDisable(code) {
    return ApiService.post("2fa/disable", { code })
  }
}
